import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import { handleOnInitiatePaymentQueryStarted } from "appRedux/helpers/paymentApiHelpers"

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: baseQueryWithMiddlewares("/payment"),
  endpoints: (builder) => ({
    initiatePayment: builder.mutation<InitiatePaymentResponseDto, InitiatePaymentRequestPayload>({
      query: (body) => ({
        url: "/initiate",
        method: "POST",
        body: body
      }),
      onQueryStarted: handleOnInitiatePaymentQueryStarted
    })
  })
})

export const {
  useInitiatePaymentMutation
} = paymentApi
